import React, { useRef, useState } from 'react';
import { Icon } from '../../Icon';
import { Popover } from '../Popover';
import { Typography } from '../Typography';
import HelpIcon from '../../../public/static/images/help.svg';
import {
  HintTooltipButton,
  HintTooltipWrapper,
  hintPopoverHorizontalAlign,
  hintPopoverStyles
} from './styled';

interface HintTooltipProps {
  text: string;
  cypress?: string;
}

export const HintTooltip: React.FC<HintTooltipProps> = ({
  text,
  cypress = 'hint-tooltip'
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const triggerRef = useRef<HTMLButtonElement>(null);

  const open = () => setIsOpen(true);
  const close = () => setIsOpen(false);
  const toggle = () => setIsOpen(prev => !prev);

  const handlePointerEnter = (event: React.PointerEvent) => {
    if (event.pointerType === 'mouse') open();
  };

  const handlePointerLeave = (event: React.PointerEvent) => {
    if (event.pointerType === 'mouse') close();
  };

  return (
    <HintTooltipWrapper>
      <HintTooltipButton
        ref={triggerRef}
        type="button"
        aria-label={text}
        onPointerEnter={handlePointerEnter}
        onPointerLeave={handlePointerLeave}
        onBlur={close}
        onClick={toggle}
        data-cy={`${cypress}-button`}
      >
        <Icon
          IconComponent={HelpIcon}
          color="transparent"
          indent={false}
          width={20}
          height={20}
        />
      </HintTooltipButton>
      <Popover
        isOpen={isOpen}
        closeHandler={close}
        triggerRef={triggerRef}
        horizontalAlign={hintPopoverHorizontalAlign}
        styles={hintPopoverStyles}
        cypress={cypress}
      >
        <Typography role="tooltip" tag="body_5" color="white">
          {text}
        </Typography>
      </Popover>
    </HintTooltipWrapper>
  );
};
